import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators  } from '@angular/forms';
import { UserService } from '../../../shared/services/user.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { CPATTERN } from '../../../shared/helpers/app.constants';

@Component({
  selector: 'app-request-support',
  templateUrl: './request-support.component.html',
  styleUrls: ['./request-support.component.scss']
})
export class RequestSupportComponent {

  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  title: AbstractControl;
  description: AbstractControl;
  constructor(private userService: UserService,
              private toasterService: ToasterService) {
    this.createForm();
  }

  createForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(50),  Validators.pattern(this.cvalidate.TEXTNUMBER)])),
      description: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(1000)])),
    });
    this.title = this.form.controls['title'];
    this.description = this.form.controls['description'];

  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.submitted = true;
      const obj = this.form.value;
      this.userService.sendSupportRequest(obj, () => {
        this.loading = false;
        this.submitted = false;
        this.form.reset();
      })
        .subscribe(
          (response) => {
            this.toasterService.showSuccess('The request support has been sent successfully');
          });
    }
  }

  noWhiteSpace() {
    let value = this.description.value;
    if (value != null && typeof value === 'string') {
      value = value.trim();
      this.description.setValue(value);
    }
  }
}
